import { CloseButton } from 'sharedComponents/Buttons';
import { Modal } from 'sharedComponents/Modal';
import { CredentialWithVerification } from 'types';
import { Box, styled } from '@mui/material';
import { VerifiedCredential } from './VerifiedCredential';
import { ATSCredentialsWithVerificationTestIds } from 'data-testids/ATS';

export const CredentialDetailModal: React.FC<{
  open: boolean;
  handleClose: () => void;
  credential: CredentialWithVerification;
}> = ({ open, handleClose, credential }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={'Verified Credential'}
      closeButton={
        <CloseButton
          onClick={handleClose}
          size="small"
          dataTestId={ATSCredentialsWithVerificationTestIds.CREDENTIAL_MODAL_CLOSE_BUTTON}
        />
      }
      bodySx={bodySx}
    >
      <ContentContainer>
        <VerifiedCredential credential={credential} />
        <img
          src={credential.screenshot_url}
          alt="Credential Screenshot"
          data-testid={ATSCredentialsWithVerificationTestIds.CREDENTIAL_MODAL_SCREENSHOT}
        />
      </ContentContainer>
    </Modal>
  );
};

const bodySx = {
  width: { xs: '95vw', md: 'min(80vw, 900px)' },
  maxWidth: { xs: '95vw', md: 'min(80vw, 900px)' },
};

const ContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));
